import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export async function getCaseBlocks(token: string, caseId: string) {
    
  const res = await axios.get(`${API}/case/${caseId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  console.log("[Segmentation Block Data]", res.data);

  return res.data as {
    [x: string]: any;
    LLMInteraction: {
      id: string;
      type: "llm";
      data: {
        prompt: string;
        response: string;
        model: string;
        confidence: number;
        stage: string;
        createdAt: string;
        userId: string;
        caseId: string;
      };
      positionIndex: number;
    }[];
    SegmentationResult: {
        
      id: string;
      type: "segmentation";
      data: {
        segmentedPlot: string;
        assymetryPlot1: string;
        assymetryplot2: string;
        colorplot: string;
        profileText: string;
        circularity: number;
        asymmetry: number;
        createdAt: string;
        userId: string;
      };
      positionIndex: number;
    }[];
       DermCase: {
      class: string;
      creationTimeUnix: number;
      id: string;
      lastUpdateTimeUnix: number;
      properties: {
        caseId: string;
        createdAt: string;
        fileName: string;
        filePath: string;
        mimeType: string;
        patientId: string;
      };
    }[];

  };
}

// 🟢 Get all cases (regardless of patient)
// export async function listAllCases(
//   token: string,
//   limit = 10,
//   offset = 0
// ) {
//   const res = await axios.get(`${API}/case/all`, {
//     params: { limit, offset },
//     headers: { Authorization: `Bearer ${token}` },
//   });
//   return res.data as any[];
// }

// 🟢 Get all cases by current user (doctor)
export async function listUserCases(
  token: string,
  search?: string,
limit = 25,
  offset = 0
) {
  const params: Record<string, string | number> = { limit, offset };
  // Only add search param if it has a value
  if (search && search.trim()) {
    params.search = search.trim();
  }
  
  const res = await axios.get(`${API}/case`, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });
  
  return res.data as {
    id: string;
    caseId: string;
    fileName: string;
    mimeType: string;
    patientId?: string;
    createdAt: string;
    userId: string;
  }[];
}

// 🔵 (Optional) Create a new case manually
export async function createCase(
  token: string,
  body: {
    caseId: string;
    fileName: string;
    contentType: string;
    filePath?: string;
  }
) {
  const res = await axios.post(`${API}/case`, body, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data as { caseId: string };
}

// 🔴 (Optional) Delete case
export async function deleteCase(token: string, caseId: string) {
  const res = await axios.delete(`${API}/case/${caseId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
}

// 🟢 Update a case (assign patient, change fileName, etc.)
export async function updateCase(
  token: string,
  caseId: string,
  body: {
    fileName?: string;
    patientId?: string;
  }
) {
  const res = await axios.patch(`${API}/case/${caseId}`, body, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
}

// 🔬 Taxonomy data interfaces for extraction 
export interface TaxonomyData {
  diagnoses: {
    primary: string[];
    differential: string[];
  };
  locations: string[];
  malignancy_risks: string[];
  characteristics: {
    colors: string[];
    sizes: string[];
    shapes: string[];
    textures: string[];
  };
  risk_factors: string[];
  total_extractions: number;
}

export interface TaxonomyFilters {
  primary_diagnoses?: string[];
  differential_diagnoses?: string[];
  malignancy_risks?: string[];
  locations?: string[];
  characteristics?: {
    [key: string]: string[];
  };
}



//// NEW BLOCK CASE 
// Entity extraction interfaces


// Add this interface
export interface CaseExtractionsResponse {
  caseId: string;
  entities: ExtractedEntity[];
  structured: StructuredExtraction | null;
  entities_found: boolean;
  structured_found: boolean;
}

// Add this function (around line 280)
// 📥 Get STORED extractions for a case (does not recreate)
// Optional versionNumber parameter to fetch version-specific extractions
export async function getCaseExtractions(
  token: string,
  caseId: string,
  versionNumber?: number
): Promise<CaseExtractionsResponse> {
  const url = versionNumber !== undefined 
    ? `${API}/case/extractions/${caseId}?version=${versionNumber}`
    : `${API}/case/extractions/${caseId}`;
  const res = await axios.get(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
}
export interface ExtractedEntity {
  entity: string;
  label: string;
  count?: number;
}

export interface EntityExtractionResponse {
  success: boolean;
  caseId: string;
  entities: ExtractedEntity[];
  conditions?: string[];
  count: number;
  stored: boolean;
}

// Structured extraction interfaces
export interface StructuredExtraction {
  finding_description: string;
  primary_diagnosis: string;
  differential_diagnoses: string[];
  finding_location: string;
  characteristics: {
    color: string;
    size: string;
    shape: string;
    texture: string;
  };
  risk_factors: string[];
  recommendations: string[];
  malignancy_risk: string;
}

export interface StructuredExtractionResponse {
  success: boolean;
  caseId: string;
  llm_blocks_count: number;
  extraction_id: string;
  extraction: StructuredExtraction;
  stored: boolean;
}

// 🔬 Get unique taxonomies for smart filtering
export async function getUniqueTaxonomies(token: string): Promise<TaxonomyData> {
  const res = await axios.post(
    `${API}/case/taxonomies/unique`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return res.data;
}

// 🔍 Filter cases by taxonomy criteria
export async function filterCasesByTaxonomies(
  token: string,
  filters: TaxonomyFilters,
  search?: string,
  limit = 25,
  offset = 0
) {
  const params: Record<string, string | number> = { limit, offset };
  if (search) params.search = search;

  const res = await axios.post(`${API}/case/filter-by-taxonomies`, filters, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });

  return res.data as {
    id: string;
    caseId: string;
    fileName: string;
    filePath?: string;
    mimeType: string;
    patientId?: string;
    createdAt: string;
    userId: string;
  }[];
}


// 🧬 Extract entities from a case
export async function extractEntities(
  token: string,
  caseId: string,
  patientId?: string
): Promise<EntityExtractionResponse> {
  const res = await axios.post(
    `${API}/extract-entities/`,
    {
      caseId,
      patientId: patientId || undefined,
    },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return res.data;
}

// 🔬 Extract structured clinical data from a case
export async function extractStructured(
  token: string,
  caseId: string,
  patientId?: string
): Promise<StructuredExtractionResponse> {
  const res = await axios.post(
    `${API}/extract-structured/`,
    {
      caseId,
      patientId: patientId || undefined,
    },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return res.data;
}

// 🔄 Migrate legacy extractions to have isActiveExtraction field
export async function migrateActiveExtractions(token: string): Promise<{
  success: boolean;
  message: string;
  totalCount: number;
  alreadySetCount?: number;
  updatedCount: number;
  failedCount?: number;
  failures?: Array<{ id: string; error: string }>;
  error?: string;
}> {
  const res = await axios.post(
    `${API}/case/migrate-active-extractions`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return res.data;
}